import { getOrderFeeDetail } from '@/plugins/util'
import * as types from '../mutation-types'
const { findIndex, remove } = require('@/plugins/lodash')

const state = {
  orderList: [],
  filter: {
    fromDate: null,
    toDate: null,
    time: null,
    status: null,
    child_ids: null,
    tags: null
  },
  scrollPosition: {
    x: undefined,
    y: undefined
  },
  offset: 0,
  total: 0,
  activeOrder: null
}

// getters
const getters = {
  orders: (state) => state.orderList,
  ordersDefaultFilter: (state) => state.filter,
  ordersPageScrollPosition: (state) => state.scrollPosition,
  ordersOffset: (state) => state.offset,
  ordersTotal: (state) => state.total,
  activeOrder: (state) => state.activeOrder
}

// actions
const actions = {
  resetOrders({ commit }) {
    commit(types.SET_ORDERS_ADD_NEW)
  },
  updateOrder({ commit }, order) {
    commit(types.SET_ORDERS_UPDATE, order)
  },
  setOrders({ commit }, orders) {
    commit(types.SET_ORDERS, orders)
  },
  setFilter({ commit }, data) {
    commit(types.SET_ORDERS_DEFAULT_FILTER, data)
  },
  setOrdersPageScrollPosition({ commit }, data) {
    commit(types.SET_ORDERS_SCROLL_POSITION, data)
  },
  setOrdersOffset({ commit }, data) {
    commit(types.SET_ORDERS_OFFSET, data)
  },
  setOrdersTotal({ commit }, data) {
    commit(types.SET_ORDERS_TOTAL, data)
  },
  setActiveOrder({ commit }, data) {
    commit(types.SET_ACTIVE_ORDER, data)
  }
}

// mutations
const mutations = {
  [types.SET_ORDERS_ADD_NEW](state) {
    state.orderList = []
  },
  [types.SET_ORDERS_UPDATE](state, order) {
    const mapedData = getOrderFeeDetail(order)
    order = { ...order, ...mapedData }

    const updateIndex = findIndex(state.orderList, { _id: order._id })
    if (updateIndex > -1) {
      if (state.filter.status === 'ALL') {
        state.orderList[updateIndex] = order
      } else {
        remove(state.orderList, (item) => {
          return item._id == order._id
        })
      }
    }
  },
  [types.SET_ORDERS](state, orders) {
    state.orderList = orders
  },
  [types.SET_ORDERS_DEFAULT_FILTER](state, { status, time, from_time, to_time, child_ids, tags }) {
    state.filter.status = status
    state.filter.time = time
    state.filter.fromDate = from_time
    state.filter.toDate = to_time
    state.filter.child_ids = child_ids
    state.filter.tags = tags
  },
  [types.SET_ORDERS_SCROLL_POSITION](state, position) {
    state.scrollPosition = position
  },
  [types.SET_ORDERS_OFFSET](state, offset) {
    state.offset = offset
  },
  [types.SET_ORDERS_TOTAL](state, total) {
    state.total = total
  },
  [types.SET_ACTIVE_ORDER](state, data) {
    state.activeOrder = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
